
import React, {useState,useEffect, useRef} from 'react';

import TwilioVideo from 'twilio-video';
import {Container, Form, Grid, Header,Segment } from 'semantic-ui-react';
import Participant from './Participant';
import Room from './Room';
// Attach the Participant's Tracks to the DOM.
function attachParticipantTracks(participant, container) {
  var tracks = Array.from(participant.tracks.values());
  attachTracks(tracks, container);
}
// Attach the Tracks to the DOM.
function attachTracks(tracks, container) {
  tracks.forEach(function(track) {
    container.appendChild(track.attach());
  });
}
function log(message) {
  var logDiv = document.getElementById('log');
  logDiv.innerHTML += '<p>&gt;&nbsp;' + message + '</p>';
  logDiv.scrollTop = logDiv.scrollHeight;
}
function TwilioVideos({token,room}) {
    const localVideoref = useRef();
    const remoteVideoref = useRef();
    // const [room, setRoom] = useState(null);
     const [participants, setParticipants] = useState([]);

    useEffect (() => {
      const participantConnected = participant => {
        setParticipants(prevParticipants => [...prevParticipants, participant]);
      };
      console.log('Trying connect Twilio');
        TwilioVideo.connect  ( token ,{
          video:true, 
          audio:true,
          name:room ,
          
        }).then((room) => {
          
          console.log('connected to twilio');
          TwilioVideo.createLocalVideoTrack().then(track => {
             localVideoref.current.appendChild(track.attach()); 
          });
          // room.participants.forEach(participantConnected);
          function addParticipant(participant){
            console.log("adding a participant");

            participant.tracks.forEach(publication => {
               if(publication.isSubscribed){
                 const track = publication.track;
                 remoteVideoref.current.appendChild(track.attach());
                 console.log("attached a track");

               }
            })
            participant.on('trackSubscribed',   track => {
              console.log('append a new t')
              remoteVideoref.current.appendChild(track.attach());
            }
            )
          }
          room.participants.forEach(addParticipant);
          room.on('participantConnected', addParticipant);
        })
        .catch((e)  => {

        console.log('error :', e);
       
       });
       return () => {
       
       }
     }, [token, room]) ;
      //  const remoteParticipants = participants.map(participant => (
      //   <Participant key={participant.sid} participant={participant} />
      // ));
       
    return (
      <div className="body">
          <h1>You are in Mag:{room}</h1>
          <div id='cal'> </div>
          {/* <a href='https://video-call-3993-dev.twil.io/video.html'>Click to start</a> */}
          <a href='https://hackathon20-fsilva.quickbase.com/db/bqygrdfns'>Back</a>
          
            <div align='left' className="Card text-muted" ref= {localVideoref} ></div>
            <div className="Card " ref= {remoteVideoref} ></div>
          
           
         
         
         <div id='log'></div><h2>
           <a href='https://airtable.com/tblWHw9cnt6Rn4ypx/viwJ9KUR5rC0btYNe?blocks=bipzjm29aMrr1W9GT' target='_blank'>Annotations</a>
         
         </h2>{/* <h3>Remote Participants</h3> */}
            
     
      </div>
    )
  }
  
  export default TwilioVideos;